import { render, staticRenderFns } from "./informationModel.vue?vue&type=template&id=2c1659bb&scoped=true"
import script from "./informationModel.vue?vue&type=script&lang=js"
export * from "./informationModel.vue?vue&type=script&lang=js"
import style0 from "./informationModel.vue?vue&type=style&index=0&id=2c1659bb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1659bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1659bb')) {
      api.createRecord('2c1659bb', component.options)
    } else {
      api.reload('2c1659bb', component.options)
    }
    module.hot.accept("./informationModel.vue?vue&type=template&id=2c1659bb&scoped=true", function () {
      api.rerender('2c1659bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/components/informationModel.vue"
export default component.exports